import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { InputWithLabel, ScrollableTabs, Switch, Text } from '@reveni-io/reveni-ui'

import { languages as constantsLanguage } from '@/common/constants'

import * as Styles from './styles'

const CustomText = ({
  languages,
  onChangeCustomText,
  customTexts,
  onCheckUseCustomText,
  useCustomText,
  supportedLanguages,
  title,
  switchLabel,
  textLanguage,
  setTextLanguage,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [titleErrors, setTitleErrors] = useState({})

  const getLanguageLabel = language => {
    return constantsLanguage(t).find(lang => lang.value === language)?.label
  }

  const handleOnBlurMessage = () => {
    supportedLanguages.forEach(lang => {
      setTitleErrors(errors => ({ ...errors, [lang]: customTexts?.[lang] ? false : true }))
    })
  }

  return (
    <Styles.Container>
      <Text type="bodyMBold">{title}</Text>
      <Switch checked={useCustomText} onChange={onCheckUseCustomText} label={switchLabel} />
      {useCustomText && (
        <Styles.TranslationContainer>
          <Styles.TabsContainer>
            <ScrollableTabs
              tabs={languages.map(language => ({
                label: getLanguageLabel(language),
                value: language,
                error: titleErrors?.[language],
              }))}
              value={textLanguage}
              onChange={setTextLanguage}
            />
            <InputWithLabel
              onChange={e => onChangeCustomText(e.target.value, textLanguage)}
              value={customTexts?.[textLanguage] || ''}
              maxLength={110}
              onBlur={handleOnBlurMessage}
              fullWidth
              backgroundColor={theme.colors.background.primary}
            />
          </Styles.TabsContainer>
        </Styles.TranslationContainer>
      )}
    </Styles.Container>
  )
}

export default CustomText
